import React, {useState} from 'react'
import {Button} from "primereact/button";
import FetchUtil from "../../../../util/FetchUtil";
import ConfigUtil from "../../../../util/ConfigUtil";
import LoginDialog from "../tournaments/LoginDialog";

/**
 * Anmeldung zum Event im Design der neuen öffentlichen Ansicht. Fachlich wie PublicTournamentRegistrationTab der alten
 * Ansicht (gleiche Endpunkte), das Turnierkennwort wird aber direkt im Formular abgefragt statt in einem eigenen Dialog.
 */
export default function AnmeldungBereich({t, isLoggedIn, isUserTeilnehmer, onRefresh}) {
    const doppelOhneDyp = t.doppelturnier && !t.dyp;
    const passwordRequired = t.kennwort !== null && t.kennwort !== undefined && t.kennwort !== "";
    const [art, setArt] = useState(doppelOhneDyp ? "idshort" : "login");

    if (!t.registrationAllowed) {
        return <div className="dhpt-inhalt-eigen">
            <section className="dhpt-karte">
                <h3 className="dhpt-karte-titel"><span>Anmeldung</span></h3>
                <div className="dhpt-gross">Anmeldung geschlossen</div>
                <p className="dhpt-hinweis">Die Anmeldung wurde vom Veranstalter deaktiviert. Vermutlich kannst du dich direkt am Turnier-/Ligatag beim
                    Veranstalter anmelden. Bei Fragen nimm gerne Kontakt zum Veranstalter auf.</p>
            </section>
        </div>
    }

    const optionen = [
        !doppelOhneDyp && {id: "login", icon: "pi pi-user", titel: "Mit Darthelfer-Zugang", empfohlen: true,
            text: "Mit deinem kostenlosen Zugang werden dir Spielstatistiken usw. direkt zugewiesen."},
        {id: "idshort", icon: "pi pi-id-card", titel: "Mit SpielerID", empfohlen: true,
            text: "Du hast schon mit Darthelfer gespielt? Deine SpielerID steht in einer Anmeldemail oder in deinem Profil."},
        {id: "anonym", icon: "pi pi-pencil", titel: "Mit deinen Daten",
            text: t.participantsMailConfirmation ? "Du gibst deine Daten ein und bestätigst die Anmeldung über eine Email." : "Du gibst deine Daten ein und bist angemeldet."},
        {id: "vorort", icon: "pi pi-map-marker", titel: "Vor Ort",
            text: "Du meldest dich direkt auf der Veranstaltung bei der Turnierleitung an."},
    ].filter(Boolean);

    const anzahl = t.tournamentPlayerEntities.length;
    const max = t.maxAnzahlTeilnehmer;
    const vorhanden = (wert) => wert !== null && wert !== undefined && wert !== "";

    return <div className="dhpt-inhalt-eigen dhpt-an">
        <section className="dhpt-karte">
            <h3 className="dhpt-karte-titel">
                <span>Anmeldung</span>
                {vorhanden(t.anmeldeendeMitUhrzeitString) && <span className="dhpt-karte-zusatz">bis {t.anmeldeendeMitUhrzeitString}</span>}
            </h3>
            <p className="dhpt-an-stand">{vorhanden(max) ? anzahl + " von " + max + " Plätzen belegt" : anzahl + " Teilnehmer angemeldet"}</p>
        </section>

        {isUserTeilnehmer && <LoginTeilnahme t={t} istTeilnehmer={true} passwordRequired={passwordRequired} onRefresh={onRefresh}/>}

        <section className="dhpt-karte">
            <h3 className="dhpt-karte-titel"><span>Wie möchtest du dich anmelden?</span></h3>
            <div className="dhpt-an-optionen" role="radiogroup" aria-label="Art der Anmeldung">
                {optionen.map(option => <button key={option.id} type="button" role="radio" aria-checked={art === option.id}
                                                className="dhpt-an-option" onClick={() => setArt(option.id)}>
                    <span className="dhpt-an-option-kopf">
                        <i className={option.icon} aria-hidden="true"/>
                        <span className="dhpt-an-option-titel">{option.titel}</span>
                        {option.empfohlen && <span className="dhpt-chip dhpt-chip-empfohlen">Empfohlen</span>}
                    </span>
                    <span className="dhpt-an-option-text">{option.text}</span>
                </button>)}
            </div>
        </section>

        {art === "login" && !isUserTeilnehmer && <LoginTeilnahme t={t} isLoggedIn={isLoggedIn} passwordRequired={passwordRequired} onRefresh={onRefresh}/>}
        {art === "idshort" && <IdShortFormular t={t} passwordRequired={passwordRequired} onRefresh={onRefresh}/>}
        {art === "anonym" && <DatenFormular t={t} passwordRequired={passwordRequired} onRefresh={onRefresh}/>}
        {art === "vorort" && <VorOrt/>}

        <Abmelden tournamentId={t.id}/>
    </div>
}

function LoginTeilnahme({t, isLoggedIn, istTeilnehmer, passwordRequired, onRefresh}) {
    const [vereinsname, setVereinsname] = useState("");
    const [kennwort, setKennwort] = useState("");
    const [showLoginDialog, setShowLoginDialog] = useState(false);
    const [meldung, setMeldung] = useState(undefined);

    const teilnahmeAendern = () => {
        setMeldung(undefined);
        // beim Abmelden ("Nicht teilnehmen") fragt das Backend kein Kennwort ab
        if (!istTeilnehmer && passwordRequired && kennwort === "") {
            setMeldung({fehler: true, text: "Bitte das Turnierkennwort eingeben."});
            return;
        }
        FetchUtil.fetchPost(ConfigUtil.getConfig().resourceUrls.tournament + "/teilnahmeAendern?tournamentid=" + t.id + "&kennwort=" + encodeURIComponent(kennwort),
            {vereinsname: vereinsname},
            message => {
                if (message === "") {
                    setMeldung({fehler: false, text: "Speichern war erfolgreich!"});
                    onRefresh();
                } else {
                    setMeldung({fehler: true, text: message});
                }
                setKennwort("");
            },
            responseNotOk => {
                setMeldung({fehler: true, text: "Fehler beim Speichern: " + responseNotOk.message});
                setKennwort("");
            },
            error => {
                setMeldung({fehler: true, text: "Fehler beim Speichern: " + error.message});
                setKennwort("");
            });
    }

    if (istTeilnehmer) {
        return <section className="dhpt-karte">
            <h3 className="dhpt-karte-titel"><span>Du bist angemeldet</span></h3>
            <p className="dhpt-hinweis">Der aktuell bei Darthelfer angemeldete Benutzer ist bereits für dieses Event angemeldet.</p>
            <Meldung meldung={meldung}/>
            <Button label="Nicht teilnehmen" icon="pi pi-times" className="p-button-outlined dhpt-button-hell" onClick={() => teilnahmeAendern()}/>
        </section>
    }

    return <section className="dhpt-karte">
        <h3 className="dhpt-karte-titel"><span>Mit Darthelfer-Zugang anmelden</span></h3>
        {isLoggedIn ? <>
            <p className="dhpt-hinweis">Du bist bei Darthelfer angemeldet.</p>
            <div className="dhpt-an-felder">
                <Feld id="dhpt-an-login-verein" label="Vereinsname" value={vereinsname} onChange={setVereinsname}/>
                {passwordRequired && <Feld id="dhpt-an-login-kennwort" label="Turnierkennwort" type="password" required={true} value={kennwort} onChange={setKennwort}
                                           hinweis="Der Veranstalter erwartet ein Kennwort zur Teilnahme."/>}
            </div>
            <Meldung meldung={meldung}/>
            <Button label="Am Event teilnehmen" icon="pi pi-plus" onClick={() => teilnahmeAendern()}/>
        </> : <>
            <p className="dhpt-hinweis">Du bist nicht bei Darthelfer angemeldet. Melde dich zuerst an, danach kannst du am Event teilnehmen.</p>
            <Button label="Login durchführen" icon="pi pi-sign-in" onClick={() => setShowLoginDialog(true)}/>
            {showLoginDialog && <LoginDialog onClose={() => setShowLoginDialog(false)}/>}
        </>}
    </section>
}

function IdShortFormular({t, passwordRequired, onRefresh}) {
    const [idShort, setIdShort] = useState("");
    const [vereinsname, setVereinsname] = useState("");
    const [kennwort, setKennwort] = useState("");
    const [meldung, setMeldung] = useState(undefined);
    const [erfolgreich, setErfolgreich] = useState(false);

    const teilnehmen = () => {
        setMeldung(undefined);
        const fehlend = [idShort === "" && "SpielerID", passwordRequired && kennwort === "" && "Turnierkennwort"].filter(Boolean);
        if (fehlend.length > 0) {
            setMeldung({fehler: true, text: "Pflichtfelder füllen: " + fehlend.join(", ")});
            return;
        }
        sendeAnmeldung("/tournamentteilnehmenIdShort", {idShort, kennwort, vereinsname, tournamentId: t.id}, setMeldung, setErfolgreich, setKennwort, onRefresh);
    }

    return <section className="dhpt-karte">
        <h3 className="dhpt-karte-titel"><span>Mit SpielerID anmelden</span></h3>
        {erfolgreich ? <Erfolg mailBestaetigung={t.participantsMailConfirmation}/> : <>
            <p className="dhpt-hinweis">Pflichtfelder sind mit * gekennzeichnet.</p>
            <div className="dhpt-an-felder">
                <Feld id="dhpt-an-idshort" label="SpielerID" required={true} value={idShort} onChange={setIdShort}/>
                <Feld id="dhpt-an-idshort-verein" label="Vereinsname" value={vereinsname} onChange={setVereinsname}/>
                {passwordRequired && <Feld id="dhpt-an-idshort-kennwort" label="Turnierkennwort" type="password" required={true} value={kennwort} onChange={setKennwort}
                                           hinweis="Der Veranstalter erwartet ein Kennwort zur Teilnahme."/>}
            </div>
            <Meldung meldung={meldung}/>
            <Button label="Anmelden" icon="pi pi-plus" onClick={() => teilnehmen()}/>
        </>}
    </section>
}

function DatenFormular({t, passwordRequired, onRefresh}) {
    const doppelOhneDyp = t.doppelturnier && !t.dyp;
    const [daten, setDaten] = useState({playername: "", name: "", vorname: "", mobil: "", email: "", strasse: "", plz: "", ort: "", vereinsname: ""});
    const [kennwort, setKennwort] = useState("");
    const [meldung, setMeldung] = useState(undefined);
    const [erfolgreich, setErfolgreich] = useState(false);

    const setze = (feld) => (wert) => setDaten(alt => ({...alt, [feld]: wert}));

    const teilnehmen = () => {
        setMeldung(undefined);
        const fehlend = [
            doppelOhneDyp && daten.playername === "" && "Doppelname",
            daten.name === "" && "Name",
            daten.vorname === "" && "Vorname",
            daten.mobil === "" && "Telefon",
            daten.email === "" && "Email",
            passwordRequired && kennwort === "" && "Turnierkennwort",
        ].filter(Boolean);
        if (fehlend.length > 0) {
            setMeldung({fehler: true, text: "Pflichtfelder füllen: " + fehlend.join(", ")});
            return;
        }
        sendeAnmeldung("/tournamentteilnehmen", {...daten, kennwort, tournamentId: t.id}, setMeldung, setErfolgreich, setKennwort, onRefresh);
    }

    return <section className="dhpt-karte">
        <h3 className="dhpt-karte-titel"><span>Mit deinen Daten anmelden</span></h3>
        {erfolgreich ? <Erfolg mailBestaetigung={t.participantsMailConfirmation}/> : <>
            <p className="dhpt-hinweis">Pflichtfelder sind mit * gekennzeichnet.</p>
            {doppelOhneDyp && <div className="dhpt-an-felder">
                <Feld id="dhpt-an-doppelname" label="Name der Einzelspieler" required={true} value={daten.playername} onChange={setze("playername")} breit={true}
                      hinweis="Beispiel: Max Mustermann + Maxi Mustermann. Die weiteren Angaben gelten für den Ansprechpartner der Doppelpaarung."/>
            </div>}
            <div className="dhpt-an-felder">
                <Feld id="dhpt-an-vorname" label="Vorname" required={true} value={daten.vorname} onChange={setze("vorname")}/>
                <Feld id="dhpt-an-name" label="Name" required={true} value={daten.name} onChange={setze("name")}/>
                <Feld id="dhpt-an-mobil" label="Mobil" type="tel" required={true} value={daten.mobil} onChange={setze("mobil")}/>
                <Feld id="dhpt-an-email" label="Email" type="email" required={true} value={daten.email} onChange={setze("email")}/>
                <Feld id="dhpt-an-strasse" label="Straße" value={daten.strasse} onChange={setze("strasse")}/>
                <Feld id="dhpt-an-plz" label="PLZ" value={daten.plz} onChange={setze("plz")}/>
                <Feld id="dhpt-an-ort" label="Ort" value={daten.ort} onChange={setze("ort")}/>
                <Feld id="dhpt-an-verein" label="Vereinsname" value={daten.vereinsname} onChange={setze("vereinsname")}/>
                {passwordRequired && <Feld id="dhpt-an-kennwort" label="Turnierkennwort" type="password" required={true} value={kennwort} onChange={setKennwort}
                                           hinweis="Der Veranstalter erwartet ein Kennwort zur Teilnahme."/>}
            </div>
            <Meldung meldung={meldung}/>
            <Button label="Anmelden" icon="pi pi-plus" onClick={() => teilnehmen()}/>
        </>}
    </section>
}

// gemeinsamer Ablauf für die Anmeldung über SpielerID bzw. eigene Daten, das Backend liefert "" bei Erfolg, sonst eine Meldung
function sendeAnmeldung(pfad, daten, setMeldung, setErfolgreich, setKennwort, onRefresh) {
    FetchUtil.fetchPost(ConfigUtil.getConfig().resourceUrls.public + pfad, daten,
        message => {
            if (message === "") {
                setErfolgreich(true);
                onRefresh();
            } else {
                setMeldung({fehler: true, text: message});
            }
            setKennwort("");
        },
        responseNotOk => {
            setMeldung({fehler: true, text: "Fehler beim Speichern: " + responseNotOk.message});
            setKennwort("");
        },
        error => {
            setMeldung({fehler: true, text: "Fehler beim Speichern: " + error.message});
            setKennwort("");
        });
}

function VorOrt() {
    return <section className="dhpt-karte">
        <h3 className="dhpt-karte-titel"><span>Vor Ort anmelden</span></h3>
        <p className="dhpt-an-text">Gehe zum Turnier und melde dich direkt bei der Turnierleitung an. Viel Spaß!</p>
        <p className="dhpt-hinweis">Nimm deine <b>SpielerID</b> mit, sie steht in deinem Profil oder in der Bestätigungsmail einer früheren Teilnahme.
            Damit geht die Anmeldung schneller und deine Spielerdaten werden miteinander verknüpft. Das ist wichtig für Ranglisten.</p>
    </section>
}

function Abmelden({tournamentId}) {
    const [offen, setOffen] = useState(false);
    const [email, setEmail] = useState("");
    const [anzahlVersuche, setAnzahlVersuche] = useState(0);
    const [meldung, setMeldung] = useState(undefined);
    const [gesendet, setGesendet] = useState(false);

    const emailGueltig = email.length > 5 && email.includes("@") && email.includes(".");

    const sendeMail = () => {
        setMeldung(undefined);
        setAnzahlVersuche(anzahlVersuche + 1);
        FetchUtil.fetchPost(ConfigUtil.getConfig().resourceUrls.public + "/deregistration/email", {tournamentId, email},
            () => setGesendet(true),
            responseNotOk => setMeldung({fehler: true, text: "Fehler: " + responseNotOk.message}),
            error => setMeldung({fehler: true, text: "Fehler: " + error.message}));
    }

    return <section className="dhpt-karte">
        <h3 className="dhpt-karte-titel"><span>Abmelden</span></h3>
        {!offen ? <>
            <p className="dhpt-hinweis">Du kannst doch nicht teilnehmen? Hier meldest du dich wieder ab.</p>
            <Button label="Vom Event abmelden" icon="pi pi-sign-out" className="p-button-outlined dhpt-button-hell" onClick={() => setOffen(true)}/>
        </> : gesendet ? <div className="dhpt-an-meldung dhpt-an-meldung-erfolg" role="status">
            Wir versuchen dir eine Email zu schicken. Sie sollte innerhalb einer Minute bei dir sein, prüfe bitte auch deinen SPAM-Ordner.
            Sofern wir die Mailadresse nicht finden, erhältst du zum Schutz unserer Teilnehmer keine Rückmeldung.
        </div> : <>
            <p className="dhpt-an-text">In deiner Anmeldemail findest du einen Link zur Abmeldung. Alternativ gibst du hier die Emailadresse ein,
                mit der du dich angemeldet hast. Finden wir sie in der Teilnehmerliste, schicken wir dir eine Email mit dem Link zur Abmeldung.</p>
            <div className="dhpt-an-felder">
                <Feld id="dhpt-an-abmelden-email" label="Email" type="email" value={email} onChange={setEmail}/>
            </div>
            <Meldung meldung={meldung}/>
            <Button label="Mail senden" icon="pi pi-envelope" disabled={!emailGueltig || anzahlVersuche > 5} onClick={() => sendeMail()}/>
        </>}
    </section>
}

function Feld({id, label, value, onChange, type = "text", required = false, hinweis, breit = false}) {
    return <div className={"dhpt-an-feld" + (breit ? " dhpt-an-feld-breit" : "")}>
        <label htmlFor={id}>{label}{required && " *"}</label>
        <input id={id} type={type} value={value} required={required} onChange={(e) => onChange(e.target.value)}
               autoComplete={type === "password" ? "off" : undefined}/>
        {hinweis && <span className="dhpt-an-feld-hinweis">{hinweis}</span>}
    </div>
}

function Meldung({meldung}) {
    if (meldung === undefined) {
        return null;
    }
    return <div className={"dhpt-an-meldung " + (meldung.fehler ? "dhpt-an-meldung-fehler" : "dhpt-an-meldung-erfolg")} role={meldung.fehler ? "alert" : "status"}>
        {meldung.text}
    </div>
}

function Erfolg({mailBestaetigung}) {
    return <div className="dhpt-an-meldung dhpt-an-meldung-erfolg" role="status">
        {mailBestaetigung ? <>
            <b>Fast geschafft!</b> Du erhältst umgehend eine Email, bitte bestätige darin deine Anmeldung. Prüfe auch deinen SPAM-Ordner.
            Die Mail ist 24 Stunden gültig. Bestätigst du die Teilnahme nicht innerhalb dieser Zeit, wirst du automatisch wieder abgemeldet.
        </> : <><b>Deine Anmeldung war erfolgreich.</b> Viel Spaß beim Event!</>}
    </div>
}
